// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:04:16

export default {
  "id": "holiday-hex-sort",
  "slug": "holiday-hex-sort",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/301305d77df24f82a9d274671b470784-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/301305d77df24f82a9d274671b470784/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Holiday Hex Sort",
      "description": "In Holiday Hex Sort, drag and drop hex tile stacks onto the board. Merge tiles to form stacks of 10 and collect them. As levels progress, more tile types appear. If there are 10 similar tiles on a stack, they will be collected. Clear all tiles by making stacks of 10 before time runs out !",
      "instructions": "Use your mouse or touchpad to drag and drop hex tile stacks onto the board. Merge tiles to create stacks of 10 and clear them. Complete the board before time runs out!",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "christmas",
        "hexa",
        "holiday",
        "real-time-strategy",
        "sorting"
      ]
    },
    "zh-CN": {
      "title": "假日六边形排序",
      "description": "在假日六边形排序游戏中，将六边形瓷砖堆拖放到板上。合并瓷砖形成10个一组并收集它们。随着关卡进度，会出现更多瓷砖类型。如果堆中有10个相同的瓷砖，它们将被收集。在时间耗尽前，通过组成10个一组的堆来清除所有瓷砖！",
      "instructions": "使用鼠标或触摸板将六边形瓦片堆拖放到棋盘上。合并瓦片以创建10个瓦片的堆并清除它们。在时间耗尽前完成棋盘！",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "圣诞节",
        "六边形",
        "假日",
        "即时策略",
        "排序"
      ]
    },
    "zh-TW": {
      "title": "假日六角排序",
      "description": "在《假日六角排序》中，將六角形瓦片堆疊拖放到棋盤上。合併瓦片形成10個堆疊並收集它們。隨著等級的提升，會出現更多瓦片類型。如果堆疊上有10個相同的瓦片，它們將被收集。在時間到之前，通過形成10個堆疊來清空所有瓦片！",
      "instructions": "使用您的滑鼠或觸控板將六邊形瓦片堆疊拖放到棋盤上。合併瓦片以創建10個堆疊並清除它們。在時間耗盡前完成棋盤！",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "聖誕節",
        "六角形",
        "節日",
        "即時策略",
        "排序"
      ]
    },
    "zh-HK": {
      "title": "假日六角排序",
      "description": "在《假日六邊形排序》中，將六邊形瓦片堆拖放至棋盤上。合併瓦片形成10個一組的堆並收集它們。隨著關卡的進行，將出現更多瓦片類型。如果堆上有10個相同的瓦片，它們將被收集。在時間耗盡前，通過組成10個一組的堆來清空所有瓦片！",
      "instructions": "使用鼠標或觸控板將六邊形地圖堆疊拖放至棋盤上。合併地圖以創造10個堆疊並清除它們。在時間耗盡前完成棋盤！",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "聖誕節",
        "六角形",
        "節日",
        "即時策略",
        "排序"
      ]
    },
    "ja": {
      "title": "ホリデイ・ヘックス・ソート",
      "description": "ホリデイ・ヘクス・ソートで、ボードにヒックス・タイルのスタックをドラッグ＆ドロップします。タイルを合体させて10枚のスタックを作り、それを収集します。レベルが進むにつれて、より多くのタイルタイプが登場します。スタックに10枚の同じタイルが並ぶと、収集されます。時間切れ前にすべてのタイルを10枚のスタックにまとめれば、ゲームクリアです！",
      "instructions": "マウスやトラックパッドを使って、六角形のタイルのスタックをボードにドラッグ＆ドロップしてください。タイルを合体させて10枚のスタックを作り、それらをクリアしてください。時間切れ前にボードを完成させましょう！",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "クリスマス",
        "ヘクサ",
        "ハロウィン",
        "リアルタイムストラテジー",
        "並べ替え"
      ]
    },
    "ko": {
      "title": "휴가 힙스 오더",
      "description": "Holliday Hex Sort에서는 보드에 힙스 타일 스택을 드래그 앤 드롭하세요. 타일을 합치어 10개의 스택을 형성하고 수집하세요. 레벨이 진행될수록 더 많은 타일 타입이 등장합니다. 스택에 10개의 동일한 타일이 있으면 수집됩니다. 시간이 지기 전에 10개의 스택을 만들어 모든 타일을 클리어하세요!",
      "instructions": "마우스나 터치패드를 사용하여 힙스 타일 스택을 보드에 드래그 앤 드롭하세요. 타일을 합쳐 10개의 스택을 만들고 그를 지우세요. 시간이 다되기 전에 보드를 완료하세요!",
      "genres": [
        "캐주얼",
        "패uzzle"
      ],
      "tags": [
        "クリ스마ス",
        "헥사",
        "홀리데이",
        "실시간 전략",
        "정렬"
      ]
    },
    "fr": {
      "title": "Hex Holiday Sort",
      "description": "Dans Holiday Hex Sort, glissez et déposez des piles de tuiles hexagonales sur le plateau. Fusionnez les tuiles pour former des piles de 10 et collectez-les. Au fur et à mesure que les niveaux progressent, plus de types de tuiles apparaissent. Si il y a 10 tuiles similaires dans une pile, elles seront collectées. Effacez toutes les tuiles en formant des piles de 10 avant que le temps ne se termine !",
      "instructions": "Utilisez votre souris ou pavé tactile pour glisser-déposer des piles de tuiles hexagonales sur le plateau. Fusionnez les tuiles pour former des piles de 10 et les éliminer. Complétez le plateau avant que le temps ne se termine !",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "Noël",
        "Hexa",
        "Fête des fêtes",
        "stratégie en temps réel",
        "trier"
      ]
    }
  }
};
